import React from 'react';

export const LicenceCartContext = React.createContext();
